import Pill from '../Pill'
import AslIcon from '@ui-components-3/icons/lib/solid/HandsAslInterpreting'

const AslInterpreterPill = () => {
  return <Pill label="ASL Interpreter Assistance" Icon={AslIcon} />
}

export default AslInterpreterPill
